import type { MessageValue } from 'contexts/intl/intlContext';
import type { IntlKey } from 'locales';

export type TranslatableContent<T extends Record<string, MessageValue> = Record<string, MessageValue>> = {
  id: IntlKey;
  values?: T;
};
export function isTranslatableContent(val: any): val is TranslatableContent {
  const castedVal = val as TranslatableContent;
  return !!castedVal.id;
}
